<template>
  <div class="flex w-full flex-col px-2">
    <ButtonScale
      v-if="scale.type == ScaleType.Buttons"
      v-model="feedback"
      :scale="scale"
      :disabled="disabled"
      :identifier="questionId"
    />
    <ImageButtonScale
      v-if="scale.type == ScaleType.ImageButtons"
      v-model="feedback"
      :scale="scale"
      :disabled="disabled"
      :identifier="questionId"
    />
    <SliderScale
      v-if="scale.type == ScaleType.Slider"
      v-model="feedback"
      :scale="scale"
      :disabled="disabled"
      :identifier="questionId"
      size="M"
    />
    <BipolarScale
      v-if="scale.type == ScaleType.Bipolar"
      v-model="feedback"
      :scale="scale"
      :disabled="disabled"
      :identifier="questionId"
    />
    <ScaleItemDescription
      v-if="scaleItemDescriptions && scaleItemDescriptions.length > 0"
      :current-selected-index="currentSelectedIndex"
      :scale-item-descriptions="scaleItemDescriptions"
    />
  </div>
</template>
<script setup lang="ts">
  import { computed } from 'vue'
  import { ScaleType, type Scale } from '../../../../core/models/scale'
  import BipolarScale from './BipolarScale.vue'
  import ButtonScale from './ButtonScale.vue'
  import ScaleItemDescription from './ScaleItemDescription.vue'
  import SliderScale from './SliderScale.vue'
  import ImageButtonScale from './ImageButtonScale.vue'
  import { FeedbackType } from '@/core/models/feedback-type.ts'

  interface Props {
    questionId: string
    scale: Scale
    type: FeedbackType
    disabled?: boolean
    scaleItemDescriptions?: ReadonlyArray<string>
  }

  const props = defineProps<Props>()

  const feedback = defineModel<number>()

  const currentSelectedIndex = computed(() => {
    return props.scale.items.findIndex((item) => item.value == feedback.value)
  })
</script>
